export const createDefaultContent = () => {
  return {
    url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pd',
    export_options: {
      filename: '',
    }
  }
};

export function getFileTypeFromUrl(url: string): string {
  try {
    const { pathname } = new URL(url);
    const filename = pathname.split('/').pop() || '';
    const extension = filename.split('.').pop()?.toLowerCase() || '';

    return extension || 'no_type';
  } catch (error) {
    return 'no_type';
  }
}
